import { IApplicationState } from '../types/redux';

export const selectWithIntroScreen = (isDesktop: boolean) => (state: IApplicationState) => {
  const isIntroKeyExisted = state.intro.fromN1 || state.intro.fromSaleRent || state.intro.fromBankiru;

  if (isIntroKeyExisted) {
    return isIntroKeyExisted;
  }

  return !isDesktop;
};
